<template>
<!-- contents -->
<div id="contents">
    <div class="contents_wrap">
        <!-- contents_head -->
        <!-- breadcrumbs -->
        <skp-breadcrumbs :setMenuId="'LEFT_0000000073'" @page-title="val => pageTitle = val" />
        <!-- //breadcrumbs -->
        <h2 class="pg_title">{{ pageTitle }}</h2>
        <!-- //contents_head -->
        <div class="view_cont" v-if="!isLoading">
            <div class="view_info">
                <div class="view_category" v-if="typeof detail.PRD_CATEGORY_NM1 !== 'undefined'">
                    {{ detail.PRD_CATEGORY_NM1 }} 
                    <em v-if="typeof detail.PRD_CATEGORY_NM2 !== 'undefined'">&gt;</em> {{ detail.PRD_CATEGORY_NM2 }} 
                    <em v-if="typeof detail.PRD_CATEGORY_NM3 !== 'undefined'">&gt;</em> {{ detail.PRD_CATEGORY_NM3 }}
                </div>
                <div class="icoBtn_wrap">
                    <a href="javascript:" class="ico_printer" @click="printContents">
                        <span class="sr_only">{{ $t('BUTTON.GLOBAL.PRINT') }}</span>
                    </a>
                </div>
            </div>
            <dl class="view_subject">
                <dt class="subject">
                    <em v-if="detail.IMPORTANCE_YN === 'Y'" class="textcolor_important">[{{ $t('FIELD.GLOBAL.IMPORTANT') }}]</em>
                    <em v-else-if="detail.MUST_READ_YN === 'Y'" class="textcolor_must">[{{ $t('FIELD.GLOBAL.MUSTREAD') }}]</em>
                    {{ detail.KNOWLEDGE_TITLE | refTitle }}
                </dt>
                <dd class="desc">
                    <span class="desc_Regist">
                        <em>{{ $t('FIELD.GLOBAL.REGISTERED.BY') }}</em>
                        {{ detail.REG_USER_NM }} ({{ detail.REG_DT }})
                    </span>
                    <span class="desc_modify">
                        <em>{{ $t('FIELD.GLOBAL.MODIFY.USER') }}</em>
                        {{ detail.MODF_USER_NM }} ({{ detail.MODF_DT }})
                    </span>
                </dd>
            </dl>

            <!-- tab -->
            <div class="view_desc">
                <!-- 200420수정 S -->
                <!-- SCMS Contents 의 경우, Symptom 및 Serial 등 추가 항목 -->
                <table v-if="isSCMS" class="data_table_ty2 mb-20">
                    <colgroup>
                        <col width="20%">
                        <col width="30%">
                        <col width="20%">
                        <col width="*">
                    </colgroup>
                    <tbody>
                        <tr>
                            <th class="text_left">{{ $t('FIELD.GLOBAL.SYMPTOM') }}</th>
                            <td>
                                <ul class="in_dotlist" v-if="symptomList.length === 0">
                                    <li>&nbsp;</li>
                                </ul>
                                <ul class="in_dotlist" v-else v-for="symptom in symptomList">
                                    <li>{{ symptom.C_CODE_T_INFO }} > {{ symptom.CODE_T_INFO }}</li>
                                </ul>
                            </td>
                            <!-- TODO Manufacture date ? -->
                            <th class="text_left">{{ $t('FIELD.KNOWLEDGE.MANUFACTURE') }}</th>
                            <td>
                                <ul class="in_dotlist" v-if="serialList.length === 0">
                                    <li>&nbsp;</li>
                                </ul>
                                <ul class="in_dotlist" v-else v-for="serial in serialList">
                                    <li>{{ serial.SERIAL_S }} ~ {{ serial.SERIAL_E }}</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <th class="text_left">{{ $t('FIELD.KNOWLEDGE.GUIDETYPE') }}</th>
                            <td>{{ getGuideTypeName }}</td>
                            <th class="text_left">{{ $t('FIELD.KNOWLEDGE.DEFECTTYPE') }}</th>
                            <td>{{ getDefectTypeName }}</td>
                        </tr>
                    </tbody>
                </table>
                <!-- //200420수정 E -->

                <div class="tab_wrap">
                    <ul class="tab_menu_02 tab_menus">
                        <li class="on" @click="changeTab($event)"><a href="javascript:">{{ $t('FIELD.GLOBAL.DESCRIPTION') }}</a></li>
                        <li @click="changeTab($event)"><a href="javascript:">{{ $t('FIELD.GLOBAL.MODEL.LIST') }}</a></li>
                        <li @click="changeTab($event)"><a href="javascript:">{{ $t('FIELD.KNOWLEDGE.PARTSLISTS') }}</a></li>
                        <li @click="changeTab($event)"><a href="javascript:">{{ $t('FIELD.KNOWLEDGE.VERHISTORY') }}</a></li>
                    </ul>
                    <div class="tab_contents">
                        <div class="tab_cont" v-html="detail.KNOWLEDGE_DESC" />
                        <div class="tab_cont">
                            <toast-grid
                                :gridId="modelGridId"
                                :ref="modelGridId"
                                :data="modelList"
                                :columns="modelColumns"
                                :options="options"
                                :pageOptions="pageOptions"
                                :isTotalCount="true"
                            />
                        </div>
                        <div class="tab_cont">
                            <toast-grid
                                :gridId="partsGridId"
                                :ref="partsGridId"
                                :data="partsList"
                                :columns="partsColumns"
                                :options="options"
                                :pageOptions="pageOptions"
                                :isTotalCount="true"
                            />
                        </div>
                        <div class="tab_cont">
                            <!-- Version Tab -->
                            <table class="data_table">
                                <colgroup>
                                    <col width="15%">
                                    <col width="15%" class="pc_only">
                                    <col width="25%" class="pc_only">
                                    <col width="*">
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>{{ $t('FIELD.GLOBAL.VERSION') }}</th>
                                        <th class="pc_only">{{ $t('FIELD.GLOBAL.DATE') }}</th>
                                        <th class="pc_only">{{ $t('FIELD.GLOBAL.EDITOR') }}</th>
                                        <th>{{ $t('FIELD.GLOBAL.DETAILS') }}</th>
                                    </tr>
                                </thead>
                                <tbody class="text_center">
                                    <tr v-if="versionList.length > 0" v-for="(version, idx) in versionList">
                                        <td>Ver.{{ version.VERSION_NO }}</td>
                                        <td class="pc_only">{{ version.MODF_DT }}</td>
                                        <td class="pc_only">{{ version.MODF_USER }}</td>
                                        <td class="text_left">
                                            {{ version.MODF_REASON }}
                                            <a  v-if="idx > 0"
                                                href="javascript:"
                                                class="txt_link"
                                                @click="seeDetailPop(version.KNOWLEDGE_ID, version.VERSION_NO)"
                                            >
                                                {{ $t('FIELD.KNOWLEDGE.SEE.DETAILS') }}
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <div v-if="isReprocess" class="btn_wrap text_right pt-10">
                                <a href="javascript:" class="txt_link" :title="$t('FIELD.KNOWLEDGE.SEE.PREVIOUS')" @click="seePrevPop">{{ $t('FIELD.KNOWLEDGE.SEE.PREVIOUS') }}</a>
                            </div>

                        </div>
                    </div>
                </div>

                <!-- Attachment -->
                <innorix-download
                    v-if="attach.length > 0"
                    :uploadId="uploadId"
                    :serviceType="serviceType"
                    :attachList="attach"
                />
                <!-- //Attachment -->
                <dl class="attachment_link" v-if="attach.length > 0">
                    <dt><a href="javascript:" class="txt_link" @click="toggleLink($event)">Having trouble downloading?</a></dt>
                    <dd>
                        <ul>
                            <li v-for="file in attach" :key="file.ENC_ATTCH_FILE_SEQ + file.ENC_TOKEN">
                                <a href="javascript:" @click="getDownloadUrl(file.ENC_ATTCH_FILE_SEQ, file.ENC_TOKEN)" class="txt_link">
                                    <span class="ico_attach"></span> {{ file.FILE_NM }}
                                </a>
                            </li>
                        </ul>
                    </dd>
                </dl>
            </div>

            <div class="btn_wrap topLine">
                <a href="javascript:" class="btn_white size_full" :title="$t('BUTTON.GLOBAL.LIST')" @click="btnList">{{ $t('BUTTON.GLOBAL.LIST') }}</a>
                <div class="btn_right pc_only" v-if="btnAuth()">
                    <a href="javascript:" class="btn_white" :title="$t('BUTTON.GLOBAL.ADD.CONTENTS')" @click="btnAddContents">{{ $t('BUTTON.GLOBAL.ADD.CONTENTS') }}</a>
                    <a href="javascript:" class="btn_white" :title="$t('BUTTON.GLOBAL.DELETE')" @click="btnDelete">{{ $t('BUTTON.GLOBAL.DELETE') }}</a>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- contents -->
</template>
<script>
import Vue                          from 'vue';
import { mapGetters }               from 'vuex';
import _                            from 'lodash';
import $                            from 'jquery';
import axios                        from 'axios';
import qs                           from 'query-string';

import store                        from '@/vuex/store';
import constants                    from '@/constants';
import SDLLocale                    from '@/mixin/SDLLocale';
import { SDLUtil, MenuUtil }        from '@/utils';
import { EventBus }                 from '@/utils/EventBus';

import ToastGrid                    from '~c/ToastGrid';
import CrossEditorViewer            from '~c/CrossEditorViewer';
import InnorixDownload              from '~c/InnorixDownload';
import SKPBreadcrumbs               from '~vb/main/SKPBreadcrumbs';

import ServiceScriptDeletePopup     from './popup/ServiceScriptDeletePopup';
import KnowledgePreviousPopup       from '~vb/knowledge/popup/KnowledgePreviousPopup';
import KnowledgeVersionDetailPopup  from '~vb/knowledge/popup/KnowledgeVersionDetailPopup';

const SCMS_CONTENTS_CD = [
    'SB',   // Service Bulletin
    'RT',   // Repair Tip
];

const fetchDetail = (knowledgeId, serviceScriptId, showType) => axios.post(
    `${SDLUtil.API_URL}/basis/myKnowledge/serviceScript/serviceScriptDetail.skp`,
    qs.stringify({ KNOWLEDGE_ID: knowledgeId, SERVICE_SCRIPT_ID: serviceScriptId, SHOW_TYPE: showType }),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

export default {
    name : 'ServiceScriptDetail',
    props : {
        knowledgeId: {},
        serviceScriptId: {},
        showType: {},
    },
    data() {
        return {
            isLoading : true,
            pageTitle: '',
            window: { width: 0, height: 0 },

            modelList: [],
            modelColumnName: [],
            partsList: [],
            symptomList: [],
            serialList: [],
            satisfaction: [],
            attachImg: [],
            detail: {},
            attach: [],
            verifyList: [],
            versionList: [],
            isReprocess: false,
            isFavorite: false,
            isRepair: false,
            isSCMS: false,

            editorId: 'editor_' + String(this.knowledgeId),

            modelGridId: 'mdlGrid_' + String(this.knowledgeId),
            modelColumns: [
                /* { header: SDLUtil.getMsgProp('FIELD.GLOBAL.SUBSIDIARY'), name: 'NMCOMPANY', align: 'center', width: 160, resizable: true, sortable: true }, */
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL.CODE'), name: 'CDMODEL', align: 'center', width: 150, resizable: true, sortable: true,
                            filter: { type: 'text', showApplyBtn: true, showClearBtn: true, state: { code: 'contain'} } },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL'), name: 'NMMODEL', align: 'center', width: 150, resizable: true, sortable: true },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MARKETINGNAME'), name: 'MAKETNM', align: 'center', width: 250, resizable: true, sortable: true },
                { header: 'CDCOMPANY', name: 'CDCOMPANY', hidden: true },
                { header: 'CDGBM', name: 'CDGBM', hidden: true },
            ],

            partsGridId: 'ptsGrid_' + String(this.knowledgeId),
            partsColumns: [
                /* 2020.04.06 Parts Name 컬럼 삭제 */
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.PARTS.ORGCODE'), name: 'PARTS_CODE', align: 'center', width: 200, resizable: true, sortable: true },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.PARTS.NEWCODE'), name: 'MODEL_CODE', align: 'center', width: 200, resizable: true, sortable: true }
            ],

            options: {
                scrollY: true,
                minBodyHeight: 80,
                bodyHeight: 265
            },
            pageOptions: {
                useClient: true,
                perPage: 20
            },

            uploadId: 'download_' + String(this.knowledgeId),
            serviceType: 'common',

            reProcessCorpNo: '',
        }
    },
    computed: {
        ...mapGetters({
            userRoles: 'getRoles',
            userCorpCd: 'getCorpCd',
            deptLevelCd: 'getDeptLevelCd',
            params: 'getParams',
        }),
        getKnowledgeId()        { return this.knowledgeId; },
        getServiceScriptId()    { return this.serviceScriptId; },
        getShowType()           { return this.showType; },
        getEditorId()           { return this.editorId; },
        getBoardCreationYN()    { return store.getters.getParams.creationYn || 'N'; },
        getDefectTypeName()     {
            let defectType = this.detail.DEFECT_TYPE || '',
                defectTypeName = { "M":"Common", "C":"Call", "R":"Repair" };

            if(!SDLUtil.isNull(defectType)) {
                return defectTypeName[defectType];
            } else {
                return  '-';
            }
        },
        getGuideTypeName() {
            let guideType = this.detail.GUIDE_TYPE || '',
                guideTypeName = {"H":"H/W", "S":"S/W", "M":"Mechanical", "A":"Accessory", "I":"Info Sharing", "E":"Others"};

            if(!SDLUtil.isNull(guideType)) {
                return guideTypeName[guideType];
            } else {
                return  '-';
            }
        }
    },
    components: {
        'skp-breadcrumbs'   : SKPBreadcrumbs,
        'toast-grid'        : ToastGrid,
        'cross-editor'      : CrossEditorViewer,
        'innorix-download'  : InnorixDownload
    },
    methods: {
        // initiation
        initLoad() {
            SDLUtil.showLoadingBar(true);
            return fetchDetail(this.getKnowledgeId, this.getServiceScriptId, this.getShowType)
                .then(res => {
                    return res.data;
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                    this.$router.go(-1);
                });
        },
        // 브라우저 리사이징 이벤트
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        printContents() {
            SDLUtil.alert({
                msg: "Print contents - " + this.getKnowledgeId
            });
        },

        // 버전 상세 보기 팝업
        seeDetailPop(knowledgeId, knowledgeVer) {
            Vue.$log.info("▶ ServiceScriptDetail.vue See Detail Popup => ", knowledgeId, knowledgeVer);
            SDLUtil.show(
                KnowledgeVersionDetailPopup,
                {
                    KNOWLEDGE_ID: knowledgeId,
                    VERSION_NO: knowledgeVer
                },
                { height: 'auto' }
            );
        },

        // 결재 이력 보기 팝업
        seeApprovalHistoryPop(approvalId) {
            Vue.$log.info("▶ ServiceScriptDetail.vue See Approval History Popup => ", approvalId);
            SDLUtil.show(
                ApprovalHistoryPopup,
                {
                    approvalId: approvalId
                },
                { height: 'auto' }
            );
        },

        // 복제 이전 버전 보기
        seePrevPop() {
            Vue.$log.info("▶ ServiceScriptDetail.vue See Previous Popup"); let prevId = this.detail['PREVIOUS_ID'] || '';
            if(!StringUtil.isNull(prevId)) {
                SDLUtil.show(
                    KnowledgePreviousPopup,
                    {
                        KNOWLEDGE_ID: prevId
                    },
                    { height: 'auto' }
                );
            }
        },

        changeTab(e) {
            var tabIndex = $('.tab_menus > li > a').index(e.target);
            if( $(e.target).hasClass('on') == true){
                $(e.target).parents('li').removeClass('on');
                $('.tab_wrap .tab_cont').hide();
            } else {
                $('.tab_wrap li').removeClass('on');
                $('.tab_wrap .tab_cont').hide();
                $(e.target).parents('li').addClass('on');
                $('.tab_wrap .tab_cont').eq(tabIndex).show();
                
                if(tabIndex == 1) this.modelList = this.modelList;
                else if(tabIndex == 2) this.partsList = this.partsList;
            }

            EventBus.$emit('grid-refresh');
        },
        btnList() {
            const params = {
                reSearch: 'Y',
                showType: this.showType
            };

            return this.$router.push({ name: 'ServiceScriptList', query: params });
        },
        btnAuth() {
            let isAuth = false;
            if( 
                SDLUtil.nvl(this.detail['SCRIPT_YN'], '') === 'Y'
             && SDLUtil.nvl(this.detail['DELETE_YN'], '') === 'N'
             && this.deptLevelCd > 1 ) {
                isAuth = true;
            }

            return isAuth;
        },
        btnAddContents() {
            if(this.deptLevelCd === 1) {
                return SDLUtil.alert('MESSAGE.AUTHORITY.NOHAVE');
            };

            let popTitle = SDLUtil.getMsgProp('TITLE.ADD.SERVICE.SCRIPT');
            store.commit('POPUP_PARAMS', {
                title: popTitle,
                knowledgeId: this.knowledgeId,
                serviceScriptId: this.serviceScriptId,
                isModify: true,
                isServiceScript: true,
                serviceScriptType: this.showType,
                reProcessCorpNo: this.reProcessCorpNo,
            });

            let linkUrl = MenuUtil.getRedirectUrl('/basis/myKnowledge/myKnowledge/register/registerForm');
            const detailPop = SDLUtil.openLegacyWindowPopup({ url: linkUrl, title: popTitle, w: 1366, h: 768 });
            let self = this,
                popTimer = window.setInterval(function() {
                    if (detailPop.closed !== false) { // !== is required for compatibility with Opera
                        window.clearInterval(popTimer);
                        self.btnList();
                    }
                }, 200);
        },
        btnDelete() {
            if(this.deptLevelCd === 1) {
                return SDLUtil.alert('MESSAGE.AUTHORITY.NOHAVE');
            };

            SDLUtil.show(
                ServiceScriptDeletePopup,
                {
                    selectedList: [{ KNOWLEDGE_ID: this.getKnowledgeId, SERVICE_SCRIPT_ID: this.getServiceScriptId }],
                    delMode: 'S',
                    showType: this.showType,
                    rtnFunc: () => {
                        this.btnList();
                    }
                },
                { height: 'auto' }
            );
        },
        getDownloadUrl(SEQ, TOKEN) {
            let cmnApiBase = `${SDLUtil.API_URL}/basis/common/attachDownload.skp`;
            return window.open(cmnApiBase + '?attachFileSeq=' + SEQ + '&encToken=' + TOKEN);
        },
        toggleLink(e) {
            $('.attachment_link > dd').toggle();
        },
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        this.reProcessCorpNo = this.$route.query.reProcessCorpNo;
        this.handleResize();

        this.initLoad().then(res => {
            Vue.$log.info("▶ ServiceScriptDetail.vue Response => ", res);
            this.symptomList = res.symptomList.rowData;
            this.serialList = res.serialList.rowData;
            this.modelList = res.modelList.rowData;
            this.modelColumnName = res.modelList.columnName;
            this.partsList = res.partsList.rowData;
            this.satisfaction = res.satisfaction.rowData;
            this.attachImg = res.attachImg.rowData;
            this.detail = res.detail.rowData[0];
            this.attach = res.attach.rowData;
            this.verifyList = res.verifyList.rowData;
            this.versionList = res.version.rowData;

            // 즐겨찾기 확인
            try{
                if(this.detail['FAVORITE'] == 0) {
                    this.isFavorite = false;
                } else {
                    this.isFavorite = true;
                };

            } catch(e) {
                this.isFavorite = false;
            };

            // 이전 버전 존재 확인
            try {
                if(SDLUtil.isNull(this.detail['PREVIOUS_ID'])) {
                    this.isPrevious = false;
                } else {
                    this.isPrevious = true;
                };

            } catch(e) {
                this.isPrevious = false;
            }

            // SCMS 컨텐츠 확인
            let menuGroupDetailCd = this.detail['MENU_GROUP_DETAIL_CD'] || '';
            if( _.includes(SCMS_CONTENTS_CD, menuGroupDetailCd) ) {
                if(menuGroupDetailCd === 'RT') this.isRepair = true;
                this.isSCMS = true;
            };

            SDLUtil.showLoadingBar(false);
            this.isLoading = false;
        });
    },
    mounted() {

    },
    beforeDestroy() {
        Vue.$log.info('▶ ServiceScriptDetail.vue beforeDestroy.');
        window.removeEventListener('resize', this.handleResize);
    },
};
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/myKnowledge/serviceScript/ServiceScriptDetail.vue